/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Tab_Duration_UnknownInputs */

const en_media_tab_duration_unknown = /** @type {(inputs: Media_Tab_Duration_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown`)
};

const fr_media_tab_duration_unknown = /** @type {(inputs: Media_Tab_Duration_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inconnu`)
};

const de_media_tab_duration_unknown = /** @type {(inputs: Media_Tab_Duration_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannt`)
};

const it_media_tab_duration_unknown = /** @type {(inputs: Media_Tab_Duration_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sconosciuto`)
};

const ru_media_tab_duration_unknown = /** @type {(inputs: Media_Tab_Duration_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неизвестный`)
};

const es_media_tab_duration_unknown = /** @type {(inputs: Media_Tab_Duration_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconocido`)
};

const zh_cn2_media_tab_duration_unknown = /** @type {(inputs: Media_Tab_Duration_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知`)
};

const ja_media_tab_duration_unknown = /** @type {(inputs: Media_Tab_Duration_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知`)
};

const hi_media_tab_duration_unknown = /** @type {(inputs: Media_Tab_Duration_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अज्ञात`)
};

const pt_pt2_media_tab_duration_unknown = /** @type {(inputs: Media_Tab_Duration_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconhecido`)
};

/**
* | output |
* | --- |
* | "Unknown" |
*
* @param {Media_Tab_Duration_UnknownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_tab_duration_unknown = /** @type {((inputs?: Media_Tab_Duration_UnknownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Tab_Duration_UnknownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_tab_duration_unknown(inputs)
	if (locale === "de") return de_media_tab_duration_unknown(inputs)
	if (locale === "it") return it_media_tab_duration_unknown(inputs)
	if (locale === "ru") return ru_media_tab_duration_unknown(inputs)
	if (locale === "es") return es_media_tab_duration_unknown(inputs)
	if (locale === "zh-CN") return zh_cn2_media_tab_duration_unknown(inputs)
	if (locale === "ja") return ja_media_tab_duration_unknown(inputs)
	if (locale === "hi") return hi_media_tab_duration_unknown(inputs)
	if (locale === "pt-PT") return pt_pt2_media_tab_duration_unknown(inputs)
	return en_media_tab_duration_unknown(inputs)
});